import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IncomeData {
  income?: any;
}

interface StepState {
  currentStep: number;
  stepsData: IncomeData;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {},
};

export const jointIncomeDetails = createSlice({
  name: "jointIncomeDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < 3) state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<IncomeData>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
    resetStepsData: (state) => {
      state.stepsData = {};
      state.currentStep = 1;
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData, resetStepsData } =
  jointIncomeDetails.actions;

export default jointIncomeDetails.reducer;
